import range from "lodash/range";

export const verticalHoverLine = {
  id: "verticalHoverLine",
  afterDatasetsDraw: function (chart) {
    const { ctx, chartArea } = chart;

    ctx.save();

    const datasetIndexes = range(chart.data.datasets.length);

    const visibleDatasetIndexes = datasetIndexes.filter((datasetIndex) => {
      if (chart.getDatasetMeta(datasetIndex).visible) {
        return datasetIndex || datasetIndex === 0; // prevent 0 from being filtered out
      }
    });

    chart.getDatasetMeta(visibleDatasetIndexes[0]).data.forEach((datapoint) => {
      if (datapoint.active) {
        ctx.beginPath();
        ctx.strokeStyle = "#bbbbbb";
        ctx.lineWidth = 1.25;
        ctx.moveTo(datapoint.x, chartArea.top - 10);
        ctx.lineTo(datapoint.x, chartArea.bottom);
        ctx.stroke();
      }
    });
  },
};
